import {parse, isAfter, startOfDay} from 'date-fns'

export default class TaskListUtils {
  static getTaskStatus(task) {

    // if the task is of type process job
    if (task.isJob) {
      // if the job is still valid
      if (!task.isInvalid) {
        // if the job has been accepted, the job is in progress
        if (task.accepted) {
          return 'job-accepted-valid';
        } else { // if the job has not been accepted
          if (task.checkIn) {
            return 'job-invitation'
          } else {
            return 'job-open-valid'
          }
        }
      } else { // if the job is expired
        // if the expired job has been accepted
        if (task.accepted) {
          return this.getTaskFutureText(task.startDate, 'job-accepted-future', 'job-accepted-invalid');
        } else { // if the expired job has not been accepted
          return this.getTaskFutureText(task.startDate, 'job-not-accepted-future', 'job-open-invalid');
        }
      }
    }

    // if the task is a role invitation
    else if (task.isRoleInvitation) {
      return 'role-invitation';
    }

    // if the task is a finished process job, so a process result
    else {
      if (task.success) {
        return 'result-success';
      } else {
        return 'result-failed';
      }
    }
  }

  /**
   * Determines if the startDate is in the future and returns @futureText
   * if in the future, if not it returns @altText
   *
   * @param taskStartDate date when task can be started
   * @param futureText text which should be displayed, if the task can only be started in the future
   * @param altText alternative text, when the task is not in the future
   * @returns {*} text
   */
  static getTaskFutureText(taskStartDate, futureText, altText) {
    let today = new Date();
    today.setHours(0, 0, 0, 0);

    const startDate = parse(taskStartDate, "dd.MM.yyyy", new Date());

    if (isAfter(startOfDay(startDate), startOfDay(today))) {
      return futureText;
    }

    return altText;
  }
}